const route = useRoute()

export const isPopup = () => {
  if (route?.query?.modal) return true
  const routerName = route.name as string
  const embedScreens = [
    'patients-patientId-documents-documentId-preview',
    'patients-patientId-exam',
    'patients-patientId-documents-documentId-survey',
    'encounters-id',
  ]
  return !!embedScreens.find((e) => e === routerName)
}
